class DashboardCustomerActivity{
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || 'dashboard-customer-activity.html'
    }
}

angular.module('emun.shopping.admin').component('dashboardCustomerActivity', new DashboardCustomerActivity());

export default DashboardCustomerActivity